<!--
  ReportSectionText.vue  —  Engine E section renderer for server type "text".
  Purpose: render the trivial text section — the server document node carries a
    single `text` field.

  reconstructed from lacak.io deployed behavior; app-specific contract verbatim,
  internal impl re-authored.

  VERBATIM (2bec.js):
    - component name ... "report-section-text"
    - consumed field ... section.text  (rendered as <div>{{ section.text }}</div>)
-->
<template>
  <div class="report-section-text">{{ section.text }}</div>
</template>

<script>
export default {
  name: 'report-section-text',
  props: {
    section: { type: Object, required: true },
  },
};
</script>

<style scoped>
.report-section-text {
  padding: 8px 12px;
  font-size: 13px;
  white-space: pre-wrap;
}
</style>
